export default function authHeader(format) {
    return { Accept: "application/" + format + "json" };
}